<template>
  <nav class="float-nav">
    <a
      v-for="item in anchorItems"
      :key="item.key"
      class="float-nav__link"
      :class="{ active: activeAnchor === item.key }"
      @click="$emit('scroll-to', item.key)"
    >
      {{ item.label }}
    </a>
  </nav>
</template>

<script>
export default {
  props: {
    anchorItems: {
      type: Array,
      default: () => []
    },
    activeAnchor: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.float-nav {
  position: fixed;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 30;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px rgba(22, 119, 255, 0.12);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: box-shadow 0.35s ease, transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.float-nav:hover {
  box-shadow: 0 14px 36px rgba(16, 61, 145, 0.2);
  transform: translateY(-50%) translateX(-3px);
}

.float-nav__link {
  display: block;
  width: 64px;
  text-align: center;
  font-size: 12px;
  color: var(--text-muted);
  line-height: 30px;
  border-radius: 8px;
  transition:
    color 0.22s ease,
    background 0.22s ease,
    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.28s ease;
  cursor: pointer;
}

.float-nav__link.active {
  color: #fff;
  background: var(--primary);
}

.float-nav__link:hover {
  color: #fff;
  background: var(--primary);
  transform: translateX(-2px) scale(1.02);
  box-shadow: 0 8px 18px rgba(22, 119, 255, 0.35);
}

@media (prefers-reduced-motion: reduce) {
  .float-nav:hover {
    transform: translateY(-50%);
  }

  .float-nav__link:hover {
    transform: none;
    box-shadow: none;
  }
}
</style>
